import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import {LinkContainer} from 'react-router-bootstrap';
import imageList from '../../imageList.json';

function GroupExample() {
  return (
   
    <Container className="Card__container">
         <LinkContainer to="/fondant">
          <a className="card__link">Fondant Cakes</a> 
        </LinkContainer>
      <CardGroup>
        {imageList.map((imagePath, index) => (
              (imagePath.indexOf('fondantCard') !== -1) &&
          <Row className="col-sm-6 col-lg-3 row-card ">
            <Card style={{display:'flex',flexWrap:'noWrap'}}>
            <Card.Img  key={index} src={`/images/${imagePath}`} alt={`Image ${index}`} />
          </Card>
          </Row>
        ))}
    </CardGroup>

    <LinkContainer to="/icing">
         <a className="card__link">Icing Cakes</a> 
      </LinkContainer>
      <CardGroup>
      {imageList.map((imagePath, index) => (
              (imagePath.indexOf('icingCard') !== -1) &&
          <Row className="col-sm-6 col-lg-3 row-card ">
            <Card style={{display:'flex',flexWrap:'noWrap'}}>
            <Card.Img   src={`/images/${imagePath}`} alt={`Image ${index}`}  />
          </Card>
          </Row>
        ))}
    </CardGroup>

      <LinkContainer to="/dessert">
        <a className="card__link">Dessert Table</a> 
      </LinkContainer>
      <CardGroup>
      {imageList.map((imagePath, index) => (
              (imagePath.indexOf('dessertCard') !== -1) &&
          <Row className="col-sm-6 col-lg-3 row-card ">
            <Card style={{display:'flex',flexWrap:'noWrap'}}>
            <Card.Img   src={`/images/${imagePath}`} alt={`Image ${index}`}  className="dessert__img"/>
          </Card>
          </Row>
        ))}
    </CardGroup>
      
    </Container>
   
  );
}

export default GroupExample;